import Axios from "axios";

const PRODUCTION_URL = "https://api3.private-radar.com/roadmap";
const DEVELOPMENT_URL = "http://localhost:5084";

export default class Services {
	// WEB SERVICES
	static async get(url) {
		if (window.location.href.indexOf("localhost") !== -1) url = DEVELOPMENT_URL + url;
		else url = PRODUCTION_URL + url;
		const token = this.getToken();
		const headers = { Authorization: `Bearer ${token}` };
		const res = await Axios.get(url, { headers });
		return res;
	}

	static async post(url, data) {
		let res = await this.request(url, "post", data);
		return res;
	}

	static async put(url, data) {
		let res = await this.request(url, "put", data);
		return res;
	}

	static async delete(url, data) {
		let res = await this.request(url, "delete", data);
		return res;
	}

	static async request(url, method, data) {
		if (window.location.href.indexOf("localhost") !== -1) url = DEVELOPMENT_URL + url;
		else url = PRODUCTION_URL + url;
		const token = this.getToken();
		try {
			const res = await Axios({
				method,
				url,
				data,
				headers: { Authorization: `Bearer ${token}` },
			});
			return res;
		} catch (err) {
			return { status: "error", error: err.message };
		}
	}

	static openPdf(url, data) {
		const token = this.getToken();
		url = `/prwsw/${url}`;
		if (window.location.href.indexOf("localhost") !== -1) url = "http://localhost" + url;

		Axios({
			method: "post",
			responseType: "blob",
			url: url,
			data: data,
			headers: { Authorization: token },
		})
			.then((response) => {
				// Check if there is an error
				if (response.data.type === "application/json") {
					alert("Error loading the file");
					return;
				}

				//Create a Blob from the PDF Stream
				const file = new Blob([response.data], {
					type: "application/pdf",
				});

				//Build a URL from the file
				const fileURL = URL.createObjectURL(file);

				//Open the URL on new Window
				window.open(fileURL);
			})
			.catch((error) => {
				console.error(error);
			});
	}
	/**
	 *
	 * @param {file} file
	 * @param {string} action
	 * @param {function} callback
	 */
	static async uploadFile(file, action, id) {
		// Create FormData
		let data = new FormData();
		data.append("file", file);
		data.append("action", action);
		if (id) data.append("id", id);
		data.append("token", this.getToken());

		// URL
		let url = "/prwsw/UploadFile";
		if (window.location.href.indexOf("localhost") !== -1) url = "http://localhost" + url;

		// const config = {
		// 	headers: {
		// 		'content-type': 'multipart/form-data'
		// 	}
		// }
		// Axios.post(url, data, config);

		const res = await Axios({
			method: "post",
			url,
			data,
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: this.getToken(),
			},
		});

		return res.data;
	}
	/**
	 * The function of Adding Mail Documents create a temporary folder
	 * on the backend to temporary hold the document before we send it.
	 * When it is sent the file is taken and added into the mails folder.
	 * @param {file} file
	 * @param {string} action -
	 * @param {id} id // -1 to create new file
	 * @param {docFolder} docFolder // " " To create new
	 */
	static async uploadFileFolder(file, action, id, docFolder) {
		let data = new FormData();
		data.append("file", file);
		data.append("action", action);
		data.append("id", id);
		data.append("doc_folder", docFolder);
		data.append("token", this.getToken());

		const token = this.getToken();
		let url = "/prwsw/UploadFile";
		if (window.location.href.indexOf("localhost") !== -1) url = "http://localhost" + url;

		const res = await Axios({
			method: "post",
			url,
			data,
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: token,
			},
		});
		return res.data;
	}

	// LOCAL STORAGE
	static getToken() {
		// Look at local storage (if we clicked on remember)
		let token = localStorage.getItem("token");
		if (token !== null) return token;

		// Look a the session storage (we did not click on remember)
		token = sessionStorage.getItem("token");
		return token;
	}

	static setToken(token, remember) {
		if (remember) return localStorage.setItem("token", token);
		return sessionStorage.setItem("token", token);
	}

	static clearToken() {
		localStorage.removeItem("token");
		return sessionStorage.removeItem("token");
	}

	static isCompany() {
		let comp = this.getCompany();
		return comp != null;
	}

	static getCompany() {
		return JSON.parse(localStorage.getItem("comp"));
	}

	static setCompany(comp) {
		// Remove user
		localStorage.setItem("user", null);

		return localStorage.setItem("comp", JSON.stringify(comp));
	}

	static getUser() {
		return JSON.parse(localStorage.getItem("user"));
	}

	static setUser(user) {
		// Remove company
		localStorage.setItem("comp", null);

		return localStorage.setItem("user", JSON.stringify(user));
	}

	static getRights() {
		return JSON.parse(localStorage.getItem("rights"));
	}

	static setRights(rights) {
		return localStorage.setItem("rights", JSON.stringify(rights));
	}

	static getSettings() {
		return JSON.parse(localStorage.getItem("settings"));
	}

	static setSettings(settings) {
		return localStorage.setItem("settings", JSON.stringify(settings));
	}
}
